<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 58">
  <defs>
    <clipPath id="link-icon">
      <path d="M36 17.31a4.83 4.83 0 00-3.47 1.43l-2.43 2.42a4.92 4.92 0 00-.7 6.12l-.88.87a5 5 0 00-2.61-.74 4.9 4.9 0 00-3.49 1.44L20 31.27a5 5 0 000 7 4.92 4.92 0 003.5 1.43 4.77 4.77 0 003.5-1.44l2.43-2.42a4.92 4.92 0 00.7-6.12l.87-.87a5 5 0 006.11-.7l2.43-2.42A4.95 4.95 0 0036 17.31zm-2.4 8.85a1 1 0 00.31-.74 1 1 0 00-.31-.75 1.1 1.1 0 00-1.49 0l-1.27 1.24a2.53 2.53 0 01.61-2.75l2.3-2.31a2.61 2.61 0 013.64 0 2.55 2.55 0 01.74 1.82 2.66 2.66 0 01-.74 1.86l-2.31 2.3a2.67 2.67 0 01-2.74.59zM24 36.9a2.58 2.58 0 01-1.83-4.4l2.32-2.31a2.56 2.56 0 011.82-.75 2.46 2.46 0 01.91.17l-1.1 1.09a1.09 1.09 0 000 1.5 1 1 0 00.75.3 1.08 1.08 0 00.75-.3l1.09-1.09a2.57 2.57 0 01-.57 2.73l-2.32 2.31a2.54 2.54 0 01-1.82.75z" clip-rule="evenodd" fill="none"/>
    </clipPath>
  </defs>
  <g id="Laag_2" data-name="Laag 2">
    <g id="Laag_1-2" data-name="Laag 1">
      <circle cx="29" cy="29" r="28" fill="#fff"/>
        <g clip-path="url(#link-icon)">
					<path class="cls-8" d="M14.83 9.56h33.9v33.9h-33.9z"/>
        </g>
      <path class="cls-8" d="M29 58a29 29 0 1129-29 29 29 0 01-29 29zm0-56a27 27 0 1027 27A27 27 0 0029 2z"/>
    </g>
  </g>
</svg>
</template>